import { Record } from 'immutable';

export default class BookingRecord extends Record({
  id: undefined,
  parent: undefined,
  attestBy: undefined,
  booked: undefined,
  bookingNumber: undefined,
  bookingResource: undefined,
  bookingResources: undefined,
  comment: undefined,
  confirmedAt: undefined,
  contact: undefined,
  createdAt: undefined,
  createdBy: undefined,
  customer: undefined,
  customerAgreement: undefined,
  customerConfirmationEmailSender: undefined,
  customerConfirmationEmailSentAt: undefined,
  customerContactEmail: undefined,
  customerContactFirstname: undefined,
  customerContactId: undefined,
  customerContactLastname: undefined,
  customerContactName: undefined,
  customerId: undefined,
  customerName: undefined,
  externalOrderNumber: undefined,
  files: undefined,
  invoices: undefined,
  links: undefined,
  publicTimeReportNotify: false,
  purchaser: undefined,
  reported: undefined,
  schemaBooking: undefined,
  services: undefined,
  staffingCompany: undefined,
}) {
}
